module.exports = __webpack_public_path__ + "img/CRIT_AIR_ze.df42f412.png";